import React from "react";
import styled from "styled-components";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";

const Wrapper = styled.div``;

const QRCode = (props) => {
  const { extra = {}, builder = false } = props;
  const { url } = extra;

  if (builder && !url) {
    return <UnconfiguredComponent hint="Add URL to component" />;
  }

  return <Wrapper>QR code will be displayed in portal</Wrapper>;
};

export default QRCode;
